// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"038c04d0","453":"43ee143f","455":"db72e700","977":"6565463c"}[chunkId] + ".chunk.js";
};